import LazyLoadModule from './LazyLoad'

class Filter {
    constructor() {
      if(document.querySelector('.js-filter') == null) return
      this.initialize()
    }

    initialize() {
      this.bindUI()
      this.bindEvent()
      if(this.windowRef.includes('?filter')) {
        this.onLoad()
      }
    }

    bindUI() {
      this.body = document.body
      this.windowRef = window.location.href
      this.mqMax = window.matchMedia( "(max-width: 1024px)" )
      this.filterWrapper = document.querySelector('.js-filter')
      if(this.filterWrapper.classList.contains('js-filter-press')) {
        this.open = document.querySelector('.js-filter-open')
        this.reset = this.open.querySelector('.js-reset')
        this.modify = this.open.querySelector('.js-modify')
        this.close = this.filterWrapper.querySelector('.js-filter-close')
        this.titles = this.filterWrapper.querySelectorAll('.js-filter-title')
      }
      this.form = document.getElementById('filters')
      this.parent = this.filterWrapper.querySelectorAll('.filters')
      this.action = this.form.getAttribute('data-action')

      if(this.filterWrapper.classList.contains('js-filter-press')) {
        this.reset.classList.remove('u-block')
        this.reset.classList.add('u-is-hidden')
        this.modify.classList.add('u-block')
        this.modify.classList.remove('u-is-hidden')
      }
    }

    bindEvent() {
      if(this.mqMax.matches && this.filterWrapper.classList.contains('js-filter-press')) {
        this.open.addEventListener('click', this.onOpen.bind(this))
        this.close.addEventListener('click', this.onClose.bind(this))
        for (let i = 0; i < this.titles.length; i++) {
          this.titles[i].addEventListener('click', this.onTitleClick.bind(this))
        }
      }

      this.parent.forEach(filterParent => {
        let filters = filterParent.querySelectorAll('.js-filter-item')

        for (var i = 0; i < filters.length; i++) {
          filters[i].addEventListener('click', this.onClick.bind(this))
        }
      })

      window.addEventListener('load', this.onLoad.bind(this))
    }

    onLoad() {
      this.parent.forEach(filterParent => {
        let filters = filterParent.querySelectorAll('.js-filter-item')

        for (var i = 0; i < filters.length; i++) {
          filters[i].checked = false
          filters[i].parentNode.classList.remove('is-active')
          this.formData = null

          if(this.windowRef.includes(`${filters[i].value}`)) {
            filters[i].checked = true
            filters[i].parentNode.classList.add('is-active')

            this.formData = new FormData()
            this.ajaxLoad(filters[i], this.formData)
          }
        }
      })
    }

    onTitleClick(e) {
      let target = e.currentTarget
      if(!target.matches('.js-filter-title')) return 

      for (let i = 0; i < this.titles.length; i++) {
        this.titles[i].classList.remove('is-active')
      }
      target.classList.add('is-active')

      if(target.childNodes.length > 1) {
        this.onClose()
      }
      
      this.reset.classList.remove('u-block')
      this.reset.classList.add('u-is-hidden')
      this.modify.classList.add('u-block')
      this.modify.classList.remove('u-is-hidden')
    }

    onOpen() {
      this.body.classList.add('filter-is-open')
    }

    onClose() {
      this.body.classList.remove('filter-is-open')
    }

    onClick(e) {
      let target = e.target

      this.formData = new FormData()
      window.history.replaceState(null, null, `?filter=${target.value}`)

      this.ajaxLoad(target, this.formData)
    }

    ajaxLoad(target, form) {
      let catSlug = target.getAttribute('data-cat')

      if(target.checked) {
        form.append(target.getAttribute('data-name'), target.value)
        if(catSlug) {
          form.append('catSlug', catSlug)
        }
        if(this.mqMax.matches && this.body.classList.contains('filter-is-open')) {
          this.onClose()
        }
      }

      for (let i = 0; i < this.parent.length; i++) {
        this.parent[i].classList.remove('is-active')
      }

      if(target.parentNode.classList.contains('js-filter-title')) {
        target.parentNode.parentNode.classList.add('is-active')
      } else if (!target.parentNode.classList.contains('js-filter-title')) {
        target.parentNode.parentNode.parentNode.classList.add('is-active')
      }

      jQuery.ajax({
        method: 'post',
        dataType: 'html',
        url: `${args.wp_ajax_url}?action=${this.action}&wp_nonce=${args.wp_nonce}`,
        data: form,
        processData: false,
        contentType: false,
        beforeSend: function() {
          if(document.querySelector('.js-filter-grid-press')) {
            document.querySelector('.js-filter-grid').style.transform = 'translate3d(0, -30px, 0)';
            document.querySelector('.js-filter-grid').style.opacity = '0';
          } else {
            document.querySelector('.js-filter-grid').style.opacity = '0'
            document.querySelector('.js-filter .js-animate').classList.remove('is-visible')
          }
        },
        success: function( data, textStatus, XMLHttpRequest ) {
          jQuery('.js-filter-grid').html( data )
          if(document.querySelector('.js-filter-grid-press')) {
            document.querySelector('.js-filter-grid-press').removeAttribute('style');
          } else {
            document.querySelector('.js-filter-grid').style.opacity = '1'
          }
          window.lazyload = new LazyLoadModule()
          window.animate.initialize()
          if(window.matchMedia( "(min-width: 1024px)" ).matches) {
            window.press.initialize()
          }
          console.log( textStatus )
          console.log( XMLHttpRequest )
        },
        error: function( MLHttpRequest, textStatus, errorThrown ) {
          console.log( MLHttpRequest )
          console.log( textStatus )
          console.log( errorThrown )
          jQuery('.js-filter-grid').html( 'Aucun article n\'\a été trouvé' )
          jQuery('.js-filter-grid').fadeIn()
        }
      });
    }
}

export default Filter
